import { api } from "."

const contactStaffApi = {
    create: async (body: {}) => {
        return await api.post('contactstaffs', body)
    },
}

export default contactStaffApi